import axios from 'axios'
import  { checkErrorData, checkErrorDataNull } from './authAction'
import  { formatList, orderByAsc, orderByDateDsc } from './format'

export function newLoan(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "CREATE_LOAN_START", payload: "" })

            console.log("new Loan START", {data})
            const res = await axios.post('/loans/new',{data})
            console.log({res});            
                        
            if (checkErrorData(res, "CREATE_LOAN_ERROR", dispatch ) ) {
				dispatch({ type: "NEW_LOAN", payload: res.data.loan })
				dispatch({ type: "CREATE_LOAN_FULFILLED", payload: "" })
                // UPDATE EQUIPEMENT
                if (res.data.loan ){
                    if (res.data.loan.loan_equipement_type === "vehicule"){
                        dispatch({ type: "UPDATE_VEHICULE", payload: res.data.equipement })
                        // dispatch({ type: "VEHICULE_LOAN_START", payload: res.data.equipement })
                        
                    } else if (res.data.loan.loan_equipement_type === "equipement") {
                        dispatch({ type: "UPDATE_EQUIPEMENT", payload: res.data.equipement })
                        // dispatch({ type: "EQUIPEMENT_LOAN_START", payload: res.data.equipement })
                    }
                }

			}
        } catch(err) {
            console.log("[ERROR] new loan ", err);
            dispatch({
                type: "CREATE_LOAN_ERROR",
                payload: err
            })
        }
    }
}
export function newLoanResa(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "CREATE_LOAN_START", payload: "" })

            console.log("new Loan START", {data})
            const res = await axios.post('/loans/new/resa',{data})
            console.log({res});            
                        
            if (checkErrorData(res, "CREATE_LOAN_ERROR", dispatch ) ) {
				dispatch({ type: "NEW_LOAN", payload: res.data.loan })
				dispatch({ type: "CREATE_LOAN_FULFILLED", payload: "" })
                // UPDATE EQUIPEMENT
                if (res.data.loan ){
                    if (res.data.loan.loan_equipement_type === "vehicule"){
                        dispatch({ type: "UPDATE_VEHICULE", payload: res.data.equipement })
                        // dispatch({ type: "VEHICULE_LOAN_START", payload: res.data.equipement })
                        
                    } else if (res.data.loan.loan_equipement_type === "equipement") {
                        dispatch({ type: "UPDATE_EQUIPEMENT", payload: res.data.equipement })
                        // dispatch({ type: "EQUIPEMENT_LOAN_START", payload: res.data.equipement })
                    }
                }

			}
        } catch(err) {
            console.log("[ERROR] new loan ", err);
            dispatch({
                type: "CREATE_LOAN_ERROR",
                payload: err
            })
        }
    }
}

export function fetchLoans() {
    return async function(dispatch){
        try{
            dispatch({ type: "FETCH_LOANS_START", payload: "" })

            console.log("fetch Loan START")
            const res = await axios.get('/loans/get/all')
            console.log({res});
            
            if (checkErrorData(res, "FETCH_LOANS_ERROR", dispatch ) ) { 
                dispatch({
                    type: "GET_LOANS",
                    payload: formatList(orderByDateDsc(res.data, "loan_start_date"), "loan_id")
                })
                // let by_user = {}
                // res.data.forEach(loan => {
                //     if (!by_user[loan.loan_user]) {
                //         by_user[loan.loan_user] = {}
                //     }
                //     by_user[loan.loan_user][loan.loan_id] = loan
                // })
                dispatch({ type: "FETCH_LOANS_FULFILLED", payload: "" })
                
            } 
        } catch(err) {
            console.log("[ERROR] get loans list ", err);
            dispatch({ type: "FETCH_LOANS_ERROR", payload: err })
        }
    }
}
export function fetchEquipementLoans(equipementID) {
    return async function(dispatch){
        try{
            dispatch({ type: "FETCH_LOANS_START", payload: "" })

            console.log("fetch Loan START")
            const res = await axios.post('/loans/equipement/get/all', {equipementID})
            console.log({res});
            
            if (checkErrorData(res, "FETCH_LOANS_ERROR", dispatch ) ) { 
                dispatch({
                    type: "GET_EQUIPEMENT_LOANS",
                    payload: {equipementID, list: formatList(orderByDateDsc(res.data, "loan_start_date"), "loan_id")}
                })
                dispatch({ type: "FETCH_LOANS_FULFILLED", payload: "" })
                
            } 
        } catch(err) {
            console.log("[ERROR] get loans list ", err);
            dispatch({ type: "FETCH_LOANS_ERROR", payload: err })
        }
    }
}

export function fetchUserLoansAdmin(userID) {
    return async function(dispatch){
        try{
            dispatch({ type: "FETCH_LOANS_START", payload: "" })

            console.log("fetch Loan START")
            const res = await axios.post('/loans/admin/user/get/all', {userID})
            console.log({res});
            
            if (checkErrorData(res, "FETCH_LOANS_ERROR", dispatch ) ) { 
                dispatch({
                    type: "GET_USER_LOANS_ADMIN",
                    payload: {userID, list: formatList(orderByDateDsc(res.data, "loan_start_date"), "loan_id")}
                })
                let equipList = res.data.map(loan => loan.equipement)
                console.log({equipList});
                dispatch({
                    type: "NEW_EQUIPEMENT_LIST",
                    payload: formatList(equipList, "equipement_id")
                })
                dispatch({ type: "FETCH_LOANS_FULFILLED", payload: "" })
                
            } 
        } catch(err) {
            console.log("[ERROR] get loans list ", err);
            dispatch({ type: "FETCH_LOANS_ERROR", payload: err })
        }
    }
}

export function fetchUserLoans() {
    return async function(dispatch){
        try{
            dispatch({ type: "FETCH_LOANS_START", payload: "" })

            console.log("fetch Loan START")
            const res = await axios.get('/loans/user/get/all')
            console.log({res});
            
            if (checkErrorData(res, "FETCH_LOANS_ERROR", dispatch ) ) { 
                let list = []
                res.data.forEach(row => {
                    let info = {}
                    Object.assign(info, row)
                    info.equipement_name = row.equipement.equipement_name
                    info.equipement_original_name = row.equipement.equipement_original_name
                    info.equipement_ref = row.equipement.equipement_ref
                    info.equipement_unique_ref = row.equipement.equipement_unique_ref
                    info.equipement_brand = row.equipement.equipement_brand
                    list.push(info)
                })
                dispatch({
                    type: "GET_USER_LOANS",
                    payload: formatList(orderByDateDsc(list, "loan_start_date"), "loan_id")
                })

                // return formatList(orderByDateDsc(res.data, "loan_start_date"), "loan_id")

                dispatch({ type: "FETCH_LOANS_FULFILLED", payload: "" })
                
            } 
        } catch(err) {
            console.log("[ERROR] get loans list ", err);
            dispatch({ type: "FETCH_LOANS_ERROR", payload: err })
        }
    }
}

export function updateLoanResa(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "UPDATE_LOAN_START", payload: "" })

            console.log("update Loan START")
            const res = await axios.post("/loans/update/resa", {data})
            console.log({res});
            
            if (checkErrorData(res, "UPDATE_LOAN_ERROR", dispatch ) ) { 
                // dispatch(refetchLoans())
                dispatch({
                    type: "UPDATE_LOAN",
                    payload: res.data
                })
                dispatch({ type: "UPDATE_LOAN_FULFILLED", payload: "" })
                // UPDATE EQUIPEMENT
                if (data.loan_equipement_type === "vehicule"){
                    dispatch({ type: "VEHICULE_LOAN_START", payload: res.data })
                    
                } else if (data.loan_equipement_type === "equipement") {
                    dispatch({ type: "EQUIPEMENT_LOAN_START", payload: res.data })

                }
            }
        } catch(err) {
            console.log("[ERROR] update loan ", err);
            dispatch({
                type: "UPDATE_LOAN_ERROR",
                payload: err
                
            })
        }
    }
}
export function endLoan(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "UPDATE_LOAN_START", payload: "" })

            console.log("update Loan START")
            const res = await axios.post("/loans/end", {data})
            console.log({res});
            
            if (checkErrorData(res, "UPDATE_LOAN_ERROR", dispatch ) ) { 
                // dispatch(refetchLoans())
                dispatch({
                    type: "UPDATE_LOAN",
                    payload: res.data.loan
                })
                dispatch({ type: "UPDATE_LOAN_FULFILLED", payload: "" })
                // UPDATE EQUIPEMENT
                if (data.loan_equipement_type === "vehicule"){
                    dispatch({ type: "VEHICULE_LOAN_END", payload: res.data.equipement })
                    
                } else if (data.loan_equipement_type === "equipement") {
                    dispatch({ type: "EQUIPEMENT_LOAN_END", payload: res.data.equipement })

                }
            }
        } catch(err) {
            console.log("[ERROR] update loan ", err);
            dispatch({
                type: "UPDATE_LOAN_ERROR",
                payload: err
                
            })
        }
    }
}


// DEMAND LOANS

export function newLoanDemand(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "CREATE_LOAN_DEMAND_START", payload: "" })

            console.log("new Loan START", {data})
            const res = await axios.post('/loans/demands/new',{data})
            console.log({res});            
                        
            if (checkErrorData(res, "CREATE_LOAN_DEMAND_ERROR", dispatch ) ) {
				dispatch({ type: "NEW_LOAN_DEMAND", payload: res.data })
				dispatch({ type: "CREATE_LOAN_DEMAND_FULFILLED", payload: "" })
                // UPDATE EQUIPEMENT

			}
        } catch(err) {
            console.log("[ERROR] new loan ", err);
            dispatch({
                type: "CREATE_LOAN_DEMAND_ERROR",
                payload: err
            })
        }
    }
}
export function updateLoanDemand(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "UPDATE_LOAN_DEMAND_START", payload: "" })

            console.log("update Loan START", {data})
            const res = await axios.post('/loans/demands/update',{data})
            console.log({res});            
                        
            if (checkErrorData(res, "UPDATE_LOAN_DEMAND_ERROR", dispatch ) ) {
				// dispatch({ type: "UPDATE_LOAN_DEMAND_USER", payload: res.data })
				dispatch({ type: "UPDATE_LOAN_DEMAND_FULFILLED", payload: "" })
			}
        } catch(err) {
            console.log("[ERROR] update loan ", err);
            dispatch({
                type: "UPDATE_LOAN_DEMAND_ERROR",
                payload: err
            })
        }
    }
}
export function deleteLoanDemand(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "DELETE_LOAN_DEMAND_START", payload: "" })

            console.log("delete demand loan START", data)
            const res = await axios.post("/loans/demand/delete", {data})
            console.log({res});

            if(checkErrorData(res, "DELETE_LOAN_DEMAND_ERROR", dispatch ) ) {
                dispatch({
                    type: "DELETE_LOAN_DEMAND",
                    payload: data,
                })
                dispatch({ type: "DELETE_LOAN_DEMAND_FULFILLED", payload: "" })
            }

        } catch(err) {
            console.log("[ERROR] delete demand loan ", err);
            dispatch({
                type: "DELETE_LOAN_DEMAND_ERROR",
                payload: err
            })
        }
    }
}
export function fetchLoanDemands() {
    return async function(dispatch){
        try{
            dispatch({ type: "FETCH_LOAN_DEMANDS_START", payload: "" })

            console.log("fetch Loan START")
            const res = await axios.get('/loans/demands/get/all')
            console.log({res});
            
            if (checkErrorData(res, "FETCH_LOAN_DEMANDS_ERROR", dispatch ) ) { 
                dispatch({
                    type: "GET_LOAN_DEMANDS",
                    payload: formatList(orderByDateDsc(res.data, "loan_start_date"), "demand_loan_id")
                })
                // let by_user = {}
                // res.data.forEach(loan => {
                //     if (!by_user[loan.loan_user]) {
                //         by_user[loan.loan_user] = {}
                //     }
                //     by_user[loan.loan_user][loan.loan_id] = loan
                // })
                dispatch({ type: "FETCH_LOAN_DEMANDS_FULFILLED", payload: "" })
                
            } 
        } catch(err) {
            console.log("[ERROR] get loans list ", err);
            dispatch({ type: "FETCH_LOAN_DEMANDS_ERROR", payload: err })
        }
    }
}


//SD: Pin: Function to get Loan
export function fetchUserLoanDemands() {
    return async function(dispatch){
        try{
            dispatch({ type: "FETCH_USER_LOAN_DEMANDS_START", payload: "" })

            console.log("fetch Loan START")
            const res = await axios.get('/loans/demands/user/get/all')
            console.log({res});
            
            if (checkErrorData(res, "FETCH_USER_LOAN_DEMANDS_ERROR", dispatch ) ) { 
                let list = []
                res.data.forEach(row => {
                    let info = {}
                    Object.assign(info, row.equipement, row)
                    list.push(info)
                })
                dispatch({
                    type: "GET_USER_LOAN_DEMANDS",
                    payload: formatList(orderByDateDsc(list, "demand_start_date"), "demand_loan_id")
                })
                
                dispatch({ type: "FETCH_USER_LOAN_DEMANDS_FULFILLED", payload: "" })
                
            } 
        } catch(err) {
            console.log("[ERROR] get loans list ", err);
            dispatch({ type: "FETCH_USER_LOAN_DEMANDS_ERROR", payload: err })
        }
    }
}
export function fetchUserLoanDemandsAdmin(userID) {
    return async function(dispatch){
        try{
            dispatch({ type: "FETCH_USER_LOAN_DEMANDS_START", payload: "" })

            console.log("fetch Loan START")
            const res = await axios.post('/loans/demands/admin/user/get/all', {userID})
            console.log({res});
            
            if (checkErrorData(res, "FETCH_USER_LOAN_DEMANDS_ERROR", dispatch ) ) { 
                dispatch({
                    type: "GET_USER_LOAN_DEMANDS_ADMIN",
                    payload: formatList(orderByDateDsc(res.data, "demand_start_date"), "demand_loan_id")
                })
                
                dispatch({ type: "FETCH_USER_LOAN_DEMANDS_FULFILLED", payload: "" })
                
            } 
        } catch(err) {
            console.log("[ERROR] get loans list ", err);
            dispatch({ type: "FETCH_USER_LOAN_DEMANDS_ERROR", payload: err })
        }
    }
}
export function fetchEquipementLoanDemands(equipementID) {
    return async function(dispatch){
        try{
            dispatch({ type: "FETCH_LOAN_DEMANDS_START", payload: "" })

            console.log("fetch Loan START")
            const res = await axios.post('/loans/demands/equipement/get/all', {equipementID})
            console.log({res});
            
            if (checkErrorData(res, "FETCH_LOAN_DEMANDS_ERROR", dispatch ) ) { 
                dispatch({
                    type: "GET_EQUIPEMENT_LOAN_DEMANDS",
                    payload: {equipementID, list: formatList(orderByDateDsc(res.data, "loan_start_date"), "loan_id")}
                })
                dispatch({ type: "FETCH_LOAN_DEMANDS_FULFILLED", payload: "" })
                
            } 
        } catch(err) {
            console.log("[ERROR] get loans list ", err);
            dispatch({ type: "FETCH_LOAN_DEMANDS_ERROR", payload: err })
        }
    }
}
export function updateResaLoanUser(data) { // accept / refuse changes for user
    return async function(dispatch){
        try{
            dispatch({ type: "UPDATE_LOAN_START", payload: "" })

            console.log("update Loan START")
            const res = await axios.post("/loans/update", {data})
            console.log({res});
            
            if (checkErrorData(res, "UPDATE_LOAN_ERROR", dispatch ) ) { 
                // dispatch(refetchLoans())
                // dispatch({
                //     type: "UPDATE_LOAN",
                //     payload: res.data
                // })
                // dispatch({
                //     type: "UPDATE_LOAN_DEMAND_USER",
                //     payload: res.data
                // })
                dispatch({ type: "UPDATE_LOAN_FULFILLED", payload: "" })
            }
        } catch(err) {
            console.log("[ERROR] update loan ", err);
            dispatch({
                type: "UPDATE_LOAN_ERROR",
                payload: err
                
            })
        }
    }
}
export function updateResaLoanAdmin(data) { // accept / refuse changes for user
    return async function(dispatch){
        try{
            dispatch({ type: "UPDATE_LOAN_START", payload: "" })

            console.log("update Loan START")
            const res = await axios.post("/loans/update", {data})
            console.log({res});
            
            if (checkErrorData(res, "UPDATE_LOAN_ERROR", dispatch ) ) { 
                dispatch({ type: "UPDATE_LOAN_FULFILLED", payload: "" })

            }
        } catch(err) {
            console.log("[ERROR] update loan ", err);
            dispatch({
                type: "UPDATE_LOAN_ERROR",
                payload: err
                
            })
        }
    }
}
export function updateDeleteLineAdmin(data) { // accept / refuse changes for user
    return async function(dispatch){
        try{
            dispatch({ type: "UPDATE_LOAN_START", payload: "" })

            console.log("update Loan START")
            const res = await axios.post("/loans/update/delete/line", {data})
            console.log({res});
            
            if (checkErrorData(res, "UPDATE_LOAN_ERROR", dispatch ) ) { 
                dispatch({ type: "UPDATE_LOAN_FULFILLED", payload: "" })

            }
        } catch(err) {
            console.log("[ERROR] update loan ", err);
            dispatch({
                type: "UPDATE_LOAN_ERROR",
                payload: err
                
            })
        }
    }
}
export function updateDemandLoanStatus(demand, status) { // admin validate demand
    return async function(dispatch){
        try{
            dispatch({ type: "UPDATE_LOAN_DEMAND_START", payload: "" })
            console.log("update Loan START")
            const res = await axios.post(`/loans/demands/update/status/${status}`, {demand})
            console.log({res});
            
            if (checkErrorData(res, "UPDATE_LOAN_DEMAND_ERROR", dispatch ) ) { 
                // dispatch(refetchLoans())
                dispatch({
                    type: "UPDATE_LOAN_DEMAND",
                    payload: res.data
                })
            }
        } catch(err) {
            console.log("[ERROR] update loan ", err);
            dispatch({
                type: "UPDATE_LOAN_DEMAND_ERROR",
                payload: err
                
            })
        }
    }
}

export function updateDemandLoanStatusUser(demandID) { // validate / send to admin after all updates over
    return async function(dispatch){
        try{
            dispatch({ type: "UPDATE_LOAN_DEMAND_START", payload: "" })
            console.log("update Loan demand START")
            const res = await axios.post(`/loans/demands/user/update/status`, {demandID})
            console.log({res});
            
            if (checkErrorData(res, "UPDATE_LOAN_DEMAND_ERROR", dispatch ) ) { 
                // dispatch(refetchLoans())
                dispatch({
                    type: "UPDATE_LOAN_DEMAND_USER",
                    payload: res.data
                })
            }
        } catch(err) {
            console.log("[ERROR] update loan ", err);
            dispatch({
                type: "UPDATE_LOAN_DEMAND_ERROR",
                payload: err
                
            })
        }
    }
}